import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import mailingActions from '../actions/mailingInformation';

function updateMailingDetails(store, action) {
    const {
        mailingDetails
    } = action.payload;

    request.post(`/${config.url_prefix}/api/updateAddress`)
        .send({
            data: mailingDetails
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(mailingActions.alertError('internal.server.error'));
            } else if (response.statusCode === 204) {
                store.dispatch(actions.changeAppState('SUMMARY'));
            } else {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(mailingActions.alertError('ipmob.error.process.request'));
            }
        });
}

export default updateMailingDetails;
